import { ReactNode } from 'react';
import { EnergyType } from 'services/api/entities';
import type { ControlComponent } from 'pages/AIMusicGenerator/components/FormulaItem';
import { FormulaField, FormulaFields } from 'services/store/remixer/types';
import { PrimaryGenreSelector } from 'pages/AIMusicGenerator/components/FormulaEditor/components/PrimaryGenreSelector';
import {
  BpmSelector,
  DurationSelector,
  EnergySelector,
} from 'pages/AIMusicGenerator/components/FormulaItem';
import { BPMIcon, DurationIcon, EnergyIcon, GenreRemixIcon } from '../icons';

type FormulaItemValues = {
  [FieldName in FormulaField['field']]: Extract<
    FormulaField,
    { field: FieldName }
  >['value'];
};

export const defaultValues: FormulaItemValues = {
  [FormulaFields.Genre]: '',
  [FormulaFields.Bpm]: 120,
  [FormulaFields.Energy]: EnergyType.ORIGINAL,
  [FormulaFields.Duration]: 130,
};

type FormulaItemComponents = {
  [FieldName in keyof FormulaItemValues]: ControlComponent<
    FormulaItemValues[FieldName]
  >;
};

export const components: FormulaItemComponents = {
  [FormulaFields.Genre]: PrimaryGenreSelector,
  [FormulaFields.Bpm]: BpmSelector,
  [FormulaFields.Energy]: EnergySelector,
  [FormulaFields.Duration]: DurationSelector,
};

type FormulaItemIcons = {
  [FieldName in keyof FormulaItemValues]: ReactNode;
};

export const icons: FormulaItemIcons = {
  [FormulaFields.Genre]: <GenreRemixIcon />,
  [FormulaFields.Bpm]: <BPMIcon />,
  [FormulaFields.Energy]: <EnergyIcon />,
  [FormulaFields.Duration]: <DurationIcon />,
};
